<template>
  <div>
    <v-dialog
      v-model="dialog"
      :persistent="dialogOptions.persistent"
      :fullscreen="isFullscreen"
      :width="dialogOptions.width"
      :transition="dialogOptions.transition"
      :retain-focus="false"
      scrollable
      content-class="engine-modal-dialog"
    >
      <v-card class="engine-modal" :class="{ 'engine-modal--fullscreen': isFullscreen }">
        <OverLay />

        <div v-if="hasParentModal" class="engine-modal__header">
          <div class="engine-modal__icon">
            <v-icon color="primary">mdi-window-maximize</v-icon>
          </div>

          <div class="engine-modal__heading">
            <div class="engine-modal__title">{{ modalTitle }}</div>
          </div>

          <v-chip v-if="dialogOptions.persistent" x-small label outlined color="primary" class="mr-2">
            <v-icon left x-small>mdi-lock-outline</v-icon>
            Persistante
          </v-chip>

          <v-btn icon aria-label="Fermer la fenêtre" :data-guide-target="`page:${page}:close`" @click="closemodal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="engine-modal__content">
          <main-component
            v-if="dialog"
            :page="page"
            :typeform="typeform"
            :modal="true"
            :parentModalKey="current"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ModalItem',
  props: ['current', 'visible'],
  components: {
    OverLay: () => import('../../outils/overlay.vue')
  },
  data() {
    return {
      page: 0,
      typeform: 0,
      pageName: '...',
      paramDialog: {},
      paramsPage: {}
    }
  },
  computed: {
    dialog: {
      get() {
        return this.visible
      },
      set(value) {
        if(!value) this.closeOutSide()
      }
    },
    dialogOptions() {
      return {
        fullscreen: false,
        persistent: false,
        transition: '',
        width: 800,
        ...(this.paramDialog || {})
      }
    },
    isFullscreen() {
      return this.$vuetify.breakpoint.xsOnly || this.dialogOptions.fullscreen === true
    },
    parentModal() {
      return this.$store.getters.modalShowParams({ type: 'parent', val: this.current })
    },
    hasParentModal() {
      return !!this.parentModal
    },
    modalTitle() {
      if(this.paramsPage.propsPage && this.parentModal) {
        return this.replaceBy({
          text: this.paramsPage.propsPage.displayname,
          page: this.parentModal.current
        })
      }
      return this.pageName
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if(value) this.initializeModal()
      }
    }
  },
  methods: {
    initializeModal() {
      const paramsPage = this.$store.getters.modalShowParams({ type: 'current', val: this.current })
      if(!paramsPage || !paramsPage.propsPage || !paramsPage.propsPage.props) return

      this.paramsPage = paramsPage
      this.page = paramsPage.propsPage.props.page
      this.typeform = paramsPage.propsPage.props.typeform
      this.pageName = paramsPage.propsPage.displayname
      this.paramDialog = paramsPage.paramDialog || {}
    },
    closemodal() {
      this.$store.dispatch('closeModal', { modalKey: this.current })
      this.page = 0
    },
    closeOutSide() {
      if(!this.dialogOptions.persistent) this.closemodal()
    }
  }
}
</script>

<style scoped>
::v-deep .engine-modal-dialog {
  margin: 12px;
  border-radius: 14px;
  box-shadow: 0 18px 55px rgba(30, 40, 75, .24);
}
.engine-modal {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: calc(100vh - 24px);
  border-radius: 14px !important;
}
.engine-modal__header {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 10px;
  min-height: 62px;
  padding: 8px 12px;
  border-bottom: 1px solid #e5e8ef;
  background: linear-gradient(
    135deg,
    var(--app-modal-header-start, #fff) 0%,
    var(--app-modal-header-end, #adadad) 100%
  );
}
.engine-modal__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(63, 81, 181, .09);
}
.engine-modal__heading { flex: 1 1 auto; min-width: 0; }
.engine-modal__eyebrow {
  color: #858b99;
  font-size: .66rem;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: .06em;
  text-transform: uppercase;
}
.engine-modal__title {
  overflow: hidden;
  margin-top: 2px;
  color: #2f3441;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.engine-modal__content {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  padding: 12px !important;

}
.engine-modal--fullscreen {
  height: 100vh;
  max-height: 100vh;
  border-radius: 0 !important;
}
@media (max-width: 600px) {
  ::v-deep .engine-modal-dialog { margin: 0; border-radius: 0; box-shadow: none; }
  .engine-modal__header { min-height: 56px; padding: 7px 8px; }
  .engine-modal__icon { flex-basis: 34px; width: 34px; height: 34px; }
  .engine-modal__header .v-chip { display: none; }
  .engine-modal__content { padding: 7px !important; }
}
</style>
